export default {
  path: 'winter-service/v2/work-orders/status',
  name: 'WinterService2WorkOrdersStatus',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/WorkOrdersStatusIndex.vue')
}
